"use client";

import useSWR from "swr";
import { PropertyDataV2 } from "commonModule/services/common";
import { apiHomePageClient } from "services/apiHomePageClient";
import DestinationRow from "./DestinationRow";
import TravelAgentPropertyCard from "./TravelAgentPropertyCard";
const fetcher = async ({
  typeId,
  isgoogle,
  allInPricing
}: {
  url: string;
} & Parameters<typeof apiHomePageClient.getPropertiesFromConfig>[0]["params"]) => {
  const data = await apiHomePageClient.getPropertiesFromConfig({
    params: {
      typeId,
      isgoogle,
      allInPricing
    }
  });
  return data?.data?.data;
};
const FeaturedPropertiesRow = ({
  initialData
}: {
  initialData: PropertyDataV2[];
}) => {
  const {
    data: properties = initialData
  } = useSWR({
    key: "/api/getPropertiesFromConfig",
    typeId: 1,
    isgoogle: false,
    allInPricing: true
  }, fetcher, {
    keepPreviousData: true,
    revalidateOnFocus: false,
    dedupingInterval: 30000,
    errorRetryCount: 1
  });
  if (!properties?.length) return null;
  return <DestinationRow title='Featured Properties' subtitle='' data-sentry-element="DestinationRow" data-sentry-component="FeaturedPropertiesRow" data-sentry-source-file="FeaturedPropertiesRow.tsx">
      {properties.map(property => <TravelAgentPropertyCard key={property._id} property={property} isLazy={false} />)}
    </DestinationRow>;
};
export default FeaturedPropertiesRow;